import { ServiceIntroMain } from "@/components/service-provide";

const ServiceVoucherAICC = () => {
  const examples = [
    {
      title: "병원에서",
      items: ["진료 예약, 위치 및 주차 안내", "휴진 시간, 주의사항 안내"],
      image: "/img/business/aicc/aicc_10.png",
    },
    {
      title: "부동산에서",
      items: ["매물 문의 및 정보 문자 전송", "위치 및 영업시간 안내"],
      image: "/img/business/aicc/aicc_11.png",
    },
    {
      title: "호텔에서",
      items: ["객실 예약 및 잔여 객실 문의", "부대시설 이용 및 예약 안내"],
      image: "/img/business/aicc/aicc_12.png",
    },
  ];

  return (
    <>
      <ServiceIntroMain />

      {/* 메인 시작하기 */}
      <section className="w-full bg-surface py-space-7 flex flex-col items-end">
        <div className="mx-auto flex max-w-container items-center justify-between">
          <img
            src="/img/business/aicc/aicc_01.png"
            alt="원하는 ARS 시나리오를 입력하는 화면 미리보기"
            className="hidden w-[300px] shrink-0 about:block"
          />

          <div className="flex flex-col items-center text-center">
            <p className="xl:text-headline-md text-title-lg font-medium text-std-black">
              PC로 한번에 끝내는 실시간 문자·전화 상담
            </p>

            <h2 className="xl:text-display-lg text-[3.8rem] font-bold text-std-black text-display-md">
              스마트한 <span className="text-std-blue">문자콜센터</span>
            </h2>

            <a
              href="https://a015.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-space-7 rounded-pill bg-[linear-gradient(150deg,#a3baec_0%,#2563EB_60%,#1D4EB9_100%)] px-space-7 py-space-3 text-title-lg font-semibold text-surface shadow-btn-primary transition-shadow hover:shadow-btn-hover inline-block text-center"
            >
              가입하고 바로 시작하기
            </a>
          </div>

          <img
            src="/img/business/aicc/aicc_02.png"
            alt="매장 위치 문자 발송, 매장 연결, 다시 듣기 카드 미리보기"
            className="hidden w-[300px] shrink-0 about:block"
          />
        </div>
      </section>

      {/* 유저 케이스 */}
      <section className="relative left-1/2 right-1/2 -mx-[50vw] w-screen lg:rounded-l-[300px] rounded-none bg-std-blue px-space-5 py-space-7 xl:py-space-9">
        <div className="mx-auto xl:max-w-container">
          <h2 className="text-center xl:text-headline-md text-headline-sm font-bold text-surface">
            부재중 전화, 텍스트 변환 안 되는 음성 메시지...
            <br className="xl:hidden block" />
            아직도 놓치고 계신가요?
          </h2>

          {/* 헤어샵 A씨 */}
          <div className="mt-space-5 flex flex-col xl:gap-space-5 w-full max-w-[900px] xl:max-w-[1160px] mx-auto">
            {/* 1인 헤어샵 운영하는 A씨 */}
            <div className="flex items-center gap-space-4 xl:gap-space-4">
              <div className="relative flex h-[120px] w-[120px] xl:h-[110px] xl:w-[160px] items-center justify-center framework-content-box shrink-0">
                <div className="absolute bottom-0 left-0 h-[55px] w-[55px] xl:h-[90px] xl:w-[90px] rounded-full bg-surface" />
                <img
                  src="/img/business/aicc/aicc_03.png"
                  alt="1인 헤어샵 운영하는 A씨"
                  className="absolute left-0 bottom-0 z-10 h-[120px] w-[120px] xl:top-0 xl:h-[170px] xl:w-[180px] object-contain"
                />
              </div>

              <div className="flex flex-col gap-space-1 xl:gap-space-2">
                <span className="text-title-sm font-regular text-surface xl:text-title-md">
                  1인 헤어샵 운영하는 A씨
                </span>
                <div className="relative rounded-[24px] bg-surface px-space-4 py-space-2 xl:px-space-5 xl:py-space-3">
                  <span className="absolute -left-[10px] bottom-[14px] xl:bottom-[18px] h-0 w-0 border-y-[6px] xl:border-y-[8px] border-r-[10px] xl:border-r-[13px] border-y-transparent border-r-surface" />
                  <p className="text-title-sm font-semibold text-std-black xl:text-title-md">
                    "고객 연령대가 높아 전화로만 응대해야 하는데, 통화로 상담할 인력이 없어요"
                  </p>
                </div>
              </div>
            </div>
            {/* 기업 대표 B씨 */}
            <div className="xl:-mt-space-4 mt-space-4 flex items-center justify-end gap-space-4">
              <div className="flex flex-col items-end gap-space-1 xl:gap-space-2">
                <span className="text-title-sm font-regular text-surface xl:text-title-md">
                  중소기업 대표 B씨
                </span>
                <div className="relative rounded-[24px] bg-surface px-space-4 py-space-2 xl:px-space-5 xl:py-space-3">
                  <span className="absolute -right-[10px] bottom-[14px] xl:bottom-[18px] h-0 w-0 border-y-[6px] xl:border-y-[8px] border-l-[10px] xl:border-l-[13px] border-y-transparent border-l-surface" />
                  <p className="text-title-sm font-semibold text-std-black xl:text-title-md">
                    "매번 똑같은 질문에 일일이 답하느라 CS팀이 너무 지쳐요"
                  </p>
                </div>
              </div>

              <div className="relative flex h-[120px] w-[120px] xl:h-[110px] xl:w-[160px] items-center justify-center shrink-0">
                <div className="absolute bottom-0 left-0 xl:left-5 h-[55px] w-[55px] xl:h-[90px] xl:w-[90px] rounded-full bg-surface" />
                <img
                  src="/img/business/aicc/aicc_04.png"
                  alt="중소기업 대표 B씨"
                  className="z-10 h-[120px] w-[120px] xl:h-[160px] xl:w-[180px] object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 특장점 */}
      <section className="w-full bg-surface py-space-9">
        <div className="mx-auto max-w-container px-space-5">
          {/* 타이틀 */}
          <div className="flex flex-col items-center gap-space-2 text-center">
            <h2 className="sm:text-headline-lg text-headline-sm font-bold text-std-black">
              골치 아픈 고객센터, 쉽게 바뀔 수 있습니다!
            </h2>
            <p className="text-title-md text-gray-5">
              우리 회사 스마트 상담센터를 간단하게 지금 바로 구축해보세요
            </p>
          </div>

          <div className="mt-space-8 grid grid-cols-1 gap-space-5 about:grid-cols-2">
            {/* 카드 1: ARS 상담 */}
            <div className="flex flex-col items-center gap-space-4 rounded-lg border border-[#EBEBEB] bg-surface p-space-5 text-center shadow-card sm:flex-row sm:items-start sm:justify-between sm:text-left">
              <div className="flex flex-col gap-space-2 pt-space-2">
                <h3 className="text-headline-sm font-bold text-gray-6">
                  <span className="text-std-blue">스마트 ARS</span> 상담 서비스
                </h3>
                <p className="text-title-sm text-gray-6">
                  복잡한 설정 없이,
                  <br className="hidden sm:inline" /> 자동으로 만드는 ARS 시스템
                </p>
              </div>
              <img
                src="/img/business/aicc/aicc_05.png"
                alt="스마트 ARS 상담 서비스 미리보기"
                className="h-[150px] w-[230px] shrink-0 object-contain"
              />
            </div>

            {/* 카드 2: 올인원 상담 채널 */}
            <div className="flex flex-col items-center gap-space-4 rounded-lg border border-[#EBEBEB] bg-surface p-space-5 text-center shadow-card sm:flex-row sm:items-start sm:justify-between sm:text-left">
              <div className="flex flex-col gap-space-2 pt-space-2">
                <h3 className="text-headline-sm font-bold text-gray-6">
                  <span className="text-std-blue">스마트 양방향 문자 솔루션 </span>
                </h3>
                <p className="text-title-sm text-gray-6">
                  주고받는 문자를 한 화면에서
                  <br className="hidden sm:inline" /> 빠르고 간편하게 응대
                </p>
              </div>
              <img
                src="/img/business/aicc/aicc_06.png"
                alt="올인원 상담 채널 미리보기"
                className="h-[150px] w-[180px] shrink-0 object-contain"
              />
            </div>

            {/* 카드 3: 웹 채팅 상담 */}
            <div className="flex flex-col items-center gap-space-4 rounded-lg border border-[#EBEBEB] bg-surface p-space-5 text-center shadow-card sm:flex-row sm:items-start sm:justify-between sm:text-left">
              <div className="flex flex-col gap-space-2 pt-space-2">
                <h3 className="text-headline-sm font-bold text-gray-6">
                  <span className="text-std-blue">웹 채팅 상담</span> 서비스
                </h3>
                <p className="text-title-sm text-gray-6">
                  고객의 문의사항을 웹사이트 내 채팅으로
                  <br className="hidden sm:inline" /> 쉽고 빠르게 해결 가능
                </p>
              </div>
              <img
                src="/img/business/aicc/aicc_07.png"
                alt="웹 채팅 상담 서비스 미리보기"
                className="h-[150px] w-[190px] shrink-0 object-contain"
              />
            </div>

            {/* 카드 4: 015 번호 */}
            <div className="flex flex-col items-center gap-space-4 rounded-lg border border-[#EBEBEB] bg-surface p-space-5 text-center shadow-card sm:flex-row sm:items-start sm:justify-between sm:text-left">
              <div className="flex flex-col gap-space-2 pt-space-2">
                <h3 className="text-headline-sm font-bold text-gray-6">
                  <span className="text-std-blue">코드 한 줄로</span> 도입
                </h3>
                <p className="text-title-sm text-gray-6">
                  단 한 줄의 코드로 5분 만에
                  <br className="hidden sm:inline" /> 웹 상담 채팅방을 완성
                </p>
              </div>
              <img
                src="/img/business/aicc/aicc_08.png"
                alt="코드 한 줄로 도입 미리보기"
                className="h-[150px] w-[230px] shrink-0 object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 문자콜센터 기능 */}
      <section className="bg-[#F0F4FF] px-4 md:px-8 lg:px-16 ">
        <div className="max-w-container w-full mx-auto flex flex-col lg:flex-row items-center justify-between xl:gap-12 gap-6 ">
          {/* 왼쪽 이미지 영역 */}
          <div className="md:flex flex-shrink-0 md:ml-space-7">
            <img
              src="/img/business/aicc/aicc_09.png"
              alt="Smart ARS Smartphone UI"
              className="lg:w-[390px] w-[230px] object-contain"
            />
          </div>
          {/* 오른쪽 영역 */}
          <div className="flex flex-col">
            <div className="mb-8 text-center lg:text-left">
              <h2 className="sm:text-headline-lg text-headline-sm font-bold text-gray-900 leading-tight">
                원하는 대로 알아서 제작되는
                <br />
                <span className="text-blue-600">스마트 자동응답 시나리오</span>
              </h2>
              <p className="mt-4 text-title-md md:text-title-lg text-gray-600 font-medium leading-relaxed">
                전문 콜센터 인력 없이도 완벽한 응대가 가능해요!
                <br />
                업종 불문, 간단한 텍스트 입력만으로 똑똑한 스마트 ARS 시나리오가 완성됩니다.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 pb-10 lg:pb-0">
              {examples.map((ex, idx) => (
                <div
                  key={idx}
                  className="flex flex-col items-start transition-transform hover:-translate-y-1"
                >
                  <span className="text-title-md font-semibold text-blue-600 mb-3 pl-1 block">
                    - {ex.title}
                  </span>

                  <div className="w-full h-[25rem] bg-white rounded-2xl py-6 px-10 shadow-sm border border-gray-100 flex flex-col justify-between items-center text-center hover:shadow-md">
                    <div className={`rounded-full flex items-center justify-center mb-4`}>
                      <img
                        src={ex.image}
                        alt={`${ex.title} icon`}
                        className="w-[130px] object-contain"
                      />
                    </div>

                    <div className="space-y-1">
                      {ex.items.map((item, itemIdx) => (
                        <p
                          key={itemIdx}
                          className="text-title-sm md:text-title-sm text-gray-500 font-medium whitespace-nowrap"
                        >
                          {item}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 웹 채팅상담 기능 */}
      <section className="relative w-full max-w-[1050px] mx-auto my-20 px-6">
        <div className="relative w-full rounded-md overflow-hidden pt-space-9 pb-space-5 px-5 md:px-20 flex items-center">
          <div className="absolute inset-0 -z-10 bg-slate-50">
            <div className="absolute top-0 left-0 w-full h-[64px] bg-slate-100 flex items-center gap-3 px-8">
              <span className="w-4 h-4 rounded-full bg-slate-300" />
              <span className="w-4 h-4 rounded-full bg-slate-300" />
              <span className="w-4 h-4 rounded-full bg-slate-300" />

              <div className="ml-4 flex-1 max-w-[520px] h-[38px] rounded-full bg-white flex items-center px-7">
                <span className="text-label-md text-slate-400 font-medium tracking-tight">
                  yourwebsite.com/home
                </span>
              </div>
            </div>

            <div className="absolute top-[64px] left-0 w-full h-[calc(100%-64px)] bg-slate-50" />
          </div>

          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-12 w-full lg:t-6 pt-space-7">
            <div className="flex-1 max-w-[600px] mx-auto ">
              {/* 메인 타이틀 */}
              <h2 className="text-center lg:text-left text-[2.4rem] md:text-[3.5rem] lg:text-[3.5rem] font-bold text-gray-900 leading-[1.25] tracking-tight">
                기다림은 제로, 해결은 실시간으로! <br />
                <span className="text-blue-600">채팅으로 만나는 스마트 상담</span>
              </h2>
              {/* 서브 설명 문구 */}
              <p className="mt-6 text-title-md md:text-title-lg text-center lg:text-left font-medium text-gray-500 leading-relaxed tracking-normal">
                고객은 웹사이트에서 편하게, 상담원은 메신저를 쓰듯{" "}
                <br className="hidden md:block" />
                하나의 플랫폼에서 매끄럽게 고객과 채팅할 수 있습니다.
              </p>
              <div className="mt-14 space-y-5">
                {/* 박스 1 */}
                <div className="flex items-start gap-5 bg-white p-6 rounded-2xl border border-gray-100/80 shadow-[0_4px_20px_rgba(0,0,0,0.02)]">
                  <div className="flex-shrink-0 w-[63px] h-[63px] flex items-center justify-center rounded-xl bg-orange-50">
                    <span className="material-icons-round text-[4rem] text-[#F58300]">sms</span>
                  </div>
                  <div>
                    <h4 className="lg:text-headline-sm text-title-md sm:text-title-lg font-bold text-[#F58300] tracking-tight">
                      문자도 가능, 채팅도 가능!
                    </h4>
                    <p className="mt-1 lg:text-title-md text-title-sm font-normal text-gray-500">
                      고객은 웹사이트를 보며 채팅하거나, 문자로도 상담이 가능합니다.
                    </p>
                  </div>
                </div>

                {/* 박스 2 */}
                <div className="flex items-start gap-5 bg-white p-6 rounded-2xl border border-gray-100/80 shadow-[0_4px_20px_rgba(0,0,0,0.02)]">
                  <div className="flex-shrink-0 w-[63px] h-[63px] flex items-center justify-center rounded-xl bg-blue-50">
                    <span className="material-icons-round text-[4rem] text-[#294780]">code</span>
                  </div>
                  <div>
                    <h4 className="lg:text-headline-sm text-title-md sm:text-title-lg text-headline-sm font-bold text-[#294780] tracking-tight">
                      코드 한 줄만 넣으면 바로 상담창 생성!
                    </h4>
                    <p className="mt-1 lg:text-title-md text-title-sm font-normal text-gray-500">
                      개발 인력 없이도 5분 만에 나만의 콜센터 구축이 가능합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="hidden lg:block flex-shrink-0 max-w-full lg:w-[320px] w-[250px] pt-space-4 self-end lg:self-center">
              <img
                src="/img/business/aicc/aicc_14.png"
                alt="웹 상담채팅 위젯 화면"
                className="w-[30rem] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </section>

      {/*  CTA 섹션  */}
      <section className="relative left-1/2 right-1/2 -mx-[50vw] w-screen bg-[#2563EB] py-[5rem] text-center text-white">
        <div className="mx-auto max-w-container flex flex-col items-center justify-center gap-10">
          {/* 메인 타이틀  */}
          <h2 className="text-white font-bold text-[2.8rem] md:text-[3.4rem] leading-[1.4] tracking-tight break-keep">
            비즈니스의 성장을 만드는 <br />
            올인원 콜센터 서비스, 문자콜센터
          </h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-2">
            {/* 가입 후 바로 이용하기 */}
            <a
              href="https://a015.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#ffffff] hover:bg-gray-200 text-std-black text-[1.6rem] md:text-[1.8rem] font-bold px-10 py-5 rounded-md shadow-sm transition-colors inline-block text-center"
            >
              가입 후 바로 이용하기
            </a>

            {/* 이용 문의 */}
            <a
              href="/voc/submit"
              className="bg-transparent hover:bg-white/10 text-white text-[1.6rem] md:text-[1.8rem] font-medium px-10 py-5 rounded-md border border-white/80 flex items-center justify-center gap-2 transition-colors inline-block text-center"
            >
              <span>이용 문의</span>
              <span className="material-icons-round text-[1.8rem] leading-none">
                arrow_forward_ios
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceVoucherAICC;
